export default {
  POST_USER_JAATHAGAN: "POST_USER_JAATHAGAN",
  POST_USER_JAATHAGAN_RESET: "POST_USER_JAATHAGAN_RESET",
  POST_USER_JAATHAGAN_MESSAGE:"POST_USER_JAATHAGAN_MESSAGE",
  CONTACT_US:"CONTACT_US"
};
